import React, {PropsWithChildren} from "react";
import {useAtomValue} from "jotai";
import {useTranslation} from "react-i18next";
import {UserGlobalRole} from "../types/domain/user";
import {authenticatedUserLoadable} from "../store/authenticatedUserStore";
import {isUserHaveAnyOfGlobalRoles} from "../utils/accessControlUtils";
import {ErrorPage} from "./pages/ErrorPage";
import {isResourceSucceeded} from "../utils/resourceUtils";

export interface Props {
    permitAnyOfGlobalRoles: UserGlobalRole[];
}

export const AuthorizationGuard: React.FC<PropsWithChildren<Props>> = ({permitAnyOfGlobalRoles, children}) => {
    const {t} = useTranslation();
    const authenticatedUserResource = useAtomValue(authenticatedUserLoadable);
    const isAuthorized =
        isResourceSucceeded(authenticatedUserResource) &&
        isUserHaveAnyOfGlobalRoles(authenticatedUserResource.data, permitAnyOfGlobalRoles);

    return isAuthorized ? <>{children}</> : <ErrorPage header={t("authorization_guard.error")} />;
};
